import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { getUserManager } from '../../shared/userManager';
import { Translate } from '../../shared/LanguageService';

type State = {
    isRedirecting: boolean;
};

class BrokerAgentAutoCreatedInfoPage extends React.Component<RouteComponentProps, State> {
    state = {
        isRedirecting: false
    };

    onContinueToLogin = async () => {
        this.setState({ isRedirecting: true });

        const params = new URLSearchParams(this.props.location.search);
        params.delete('autocreatedbrokeragent');

        const queryString = params.toString();
        const nextUrl = `/orders/new${queryString ? `?${queryString}` : ''}`;

        await getUserManager().signinRedirect({ data: { nextUrl } });
    };

    render() {
        return (
            <div className="container">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <h3>{Translate('orders/auto-created-broker-agent/title')}</h3>
                        <p>{Translate('orders/auto-created-broker-agent/body1')}</p>
                        <p>{Translate('orders/auto-created-broker-agent/body2')}</p>
                        <button
                            type="button"
                            className="btn btn-primary"
                            disabled={this.state.isRedirecting}
                            onClick={this.onContinueToLogin}
                        >
                            {this.state.isRedirecting
                                ? Translate('orders/auto-created-broker-agent/button-redirecting')
                                : Translate('orders/auto-created-broker-agent/button-go-to-login')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default BrokerAgentAutoCreatedInfoPage;